export const DEFAULT_SKIN = 'light';

export const SKIN_COLOR = {
  light: 'D40-20',
  dark: 'D80-20',
};
